import '@vanilla-extract/css/vanilla.virtual.css?ve-css=LmhwbnFvZDAgewogIGhlaWdodDogMjJweDsKICB3aWR0aDogYXV0bzsKfQ';
export var BlinqLogoStyle = 'hpnqod0';